module.exports = __webpack_public_path__ + "img/stock2.4dc12e9c.png";